import BrButton from '@govbr/react-components/lib/BrButton';
import { Grid } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { trackServiceSelect } from '../../common/tracker';
import Accordion from '../../components/Accordion/Accordion';
import AjudaRapida from '../../components/AjudaRapida/AjudaRapida';
import Card from '../../components/Card/Card';
import MainContainer from '../../components/MainContainer/MainContainer';
import styles from './PainelBeneficios.module.css';
import {
  alterarBeneficioSelecionado,
  alterarDataFinal,
  alterarDataInicial,
  alterarMensagem,
  ativarMensagem,
  limparTiposBeneficios,
  obterExtratoBeneficio,
  obterFamilia,
  obterTiposBeneficios,
  selectFamilia,
  selectTiposBeneficios,
  selectState,
  obterExtratoConsignados,
  selectExtratoConsignado,
  limparConsignados,
  alterarMensagemConsignado,
  ativarMensagemConsignado} from './BeneficiosSlice';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { useEffect, useState } from 'react';
import auth from '../../auth/Auth';
import { tipoBeneficios } from '../../common/enum'
import { getSituacaoCadastroFamilia, selectPerfilCompleto, selectSituacaoCadastroFamilia } from '../Perfil/perfilSlice';
import imgAlerta from '../../assets/img/icone-alerta.png';
import Message from '../../components/Message/Message';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { authLogout, selectGovBr } from '../../auth/authSlice';
import { selectLogado } from '../IdentificacaoPositiva/identificacaoPositivaSlice';
import { selectLoadingCount } from '../../globalSlice';
import { Dialog, DialogContent } from '@material-ui/core';
import { obterMesAnoExtenso } from '../../common/formatadores';
import { obterNomeDoPerfil } from '../../common/perfilUtils';

const PainelBeneficios: React.FC = (props) => {
  const history = useHistory();
  const dispatch = useAppDispatch();

  const familia = useAppSelector(selectFamilia);
  const perfil = useAppSelector(selectPerfilCompleto);
  const situacaoCadastroFamilia = useAppSelector(selectSituacaoCadastroFamilia);
  const tiposBeneficios = useAppSelector(selectTiposBeneficios);

  const govBrLogado = useAppSelector(selectGovBr).logado;
  const isAuthenticatedIdPositiva = useAppSelector(selectLogado);
  const state = useAppSelector(selectState);

  const extratosConsignado = useAppSelector(selectExtratoConsignado);
  const loadingCount = useAppSelector(selectLoadingCount);

  const [ajudaAcionada, setAjudaAcionada] = useState(false);
  const [mensagemAjuda, setMensagemAjuda] = useState('');

  useEffect(() => {
    return () => {
      dispatch(limparTiposBeneficios());
      dispatch(alterarMensagem(''));
      dispatch(ativarMensagem(false));
    }
  }, [dispatch]);

  useEffect(() => {
    if (!situacaoCadastroFamilia) {
      dispatch(getSituacaoCadastroFamilia({ cpf: auth.getUser(), history }));
    }

    if (!familia && perfil?.numeroFamiliar) {
      dispatch(obterFamilia(auth.getUser()));
    }

    if (tiposBeneficios === null && perfil) {
      const dados = {
        nuFamiliar : perfil?.numeroFamiliar,
        tipoPerfil: perfil?.tipoPerfil,
        cpf: perfil?.cpf,
      }

      dispatch(obterTiposBeneficios(dados));
    }

    if (!extratosConsignado) {
      const dados = {
        nuFamiliar : perfil?.numeroFamiliar
      }

      dispatch(obterExtratoConsignados(dados));
    }
  }, [dispatch, situacaoCadastroFamilia, perfil, history, familia, tiposBeneficios, extratosConsignado]);

  const voltarParaPainel = () => {
    dispatch(limparConsignados());
    dispatch(alterarMensagemConsignado(''));
    dispatch(ativarMensagemConsignado(false));

    history.push('/home');
  };

  const mostrarProgramasSociais = () => {
    trackServiceSelect('MAIS-OPCOES', "PROGRAMAS SOCIAIS");
    history.push('/programas-sociais');
  }

  const mostrarTodos = async () => {

    let qtdMesesAnteriores = 5;

    let periodoFinal = new Date()
    let periodoInicial = new Date(periodoFinal.getFullYear(), periodoFinal.getMonth() - qtdMesesAnteriores, 1)

    const dados = {
      nuFamiliar : perfil?.numeroFamiliar,
      tipoPerfil: perfil?.tipoPerfil,
      cpf: perfil?.cpf,
      tipoConsulta: tipoBeneficios[0].value,
      dataInicial: periodoInicial,
      dataFinal: periodoFinal
    }

    await dispatch(alterarDataInicial(periodoInicial))
    await dispatch(alterarDataFinal(periodoFinal))

    await dispatch(alterarBeneficioSelecionado(tipoBeneficios[0].value));
    await dispatch(obterExtratoBeneficio(dados));
    history.push('/extratoBeneficios');
  }

  const atualizarPeriodoConsultaBeneficios = async(competencia: String) => {
    let maxCompetencia = competencia.toString()

    let qtdMesesAnteriores = 5

    const year = maxCompetencia.slice(0, 4)
    const month = maxCompetencia.slice(4, 6)
    const periodoFinal = new Date(parseInt(year), parseInt(month), 0)
    const periodoInicial = new Date(periodoFinal.getFullYear(), periodoFinal.getMonth() - qtdMesesAnteriores, 1)

    await dispatch(alterarDataInicial(periodoInicial))
    await dispatch(alterarDataFinal(periodoFinal))

    return { periodoInicial, periodoFinal }
  }

  const mostrarAuxilioBrasil = async () => {
    let tipoConsulta = tipoBeneficios[1].value

    let periodo = await atualizarPeriodoConsultaBeneficios(tiposBeneficios.maxCompetenciaPAB)

    const dados = {
      nuFamiliar : perfil?.numeroFamiliar,
      tipoPerfil: perfil?.tipoPerfil,
      cpf: perfil?.cpf,
      tipoConsulta,
      dataInicial: periodo.periodoInicial,
      dataFinal: periodo.periodoFinal
    }

    await dispatch(alterarBeneficioSelecionado(tipoConsulta))
    await dispatch(obterExtratoBeneficio(dados))
    history.push('/extratoBeneficios')
  }

  const mostrarBPC = async () => {
    let tipoConsulta = tipoBeneficios[2].value

    let periodo = await atualizarPeriodoConsultaBeneficios(tiposBeneficios.maxCompetenciaBPC)

    const dados = {
      nuFamiliar : perfil?.numeroFamiliar,
      tipoPerfil: perfil?.tipoPerfil,
      cpf: perfil?.cpf,
      tipoConsulta,
      dataInicial: periodo.periodoInicial,
      dataFinal: periodo.periodoFinal
    }

    await dispatch(alterarBeneficioSelecionado(tipoConsulta));
    await dispatch(obterExtratoBeneficio(dados));
    history.push('/extratoBeneficios');
  }

  const mostrarAuxilioInclusao = async () => {
    let tipoConsulta = tipoBeneficios[3].value

    let periodo = await atualizarPeriodoConsultaBeneficios(tiposBeneficios.maxCompetenciaAI)

    const dados = {
      nuFamiliar : perfil?.numeroFamiliar,
      tipoPerfil: perfil?.tipoPerfil,
      cpf: perfil?.cpf,
      tipoConsulta,
      dataInicial: periodo.periodoInicial,
      dataFinal: periodo.periodoFinal
    }

    await dispatch(alterarBeneficioSelecionado(tipoConsulta));
    await dispatch(obterExtratoBeneficio(dados));
    history.push('/extratoBeneficios');
  }

  // const mostrarTarifaSocialEnergiaEletrica = async () => {
  //   let tipoConsulta = tipoBeneficios[4].value

  //   let periodo = await atualizarPeriodoConsultaBeneficios(tiposBeneficios.maxCompetenciaTSEE)

  //   const dados = {
  //     nuFamiliar : perfil?.numeroFamiliar,
  //     tipoPerfil: perfil?.tipoPerfil,
  //     cpf: perfil?.cpf,
  //     tipoConsulta,
  //     dataInicial: periodo.periodoInicial,
  //     dataFinal: periodo.periodoFinal
  //   }

  //   await dispatch(alterarBeneficioSelecionado(tipoConsulta));
  //   await dispatch(obterExtratoBeneficio(dados));
  //   history.push('/extratoBeneficios');
  // }

  const mostrarExtratoConsignado = async () => {
    trackServiceSelect('POR-CONFIRMAÇÃO', "EMPRÉSTIMOS CONSIGNADOS");
    history.push('/extratoConsignado');
  }

  const isLogado = () => {
    return (govBrLogado && situacaoCadastroFamilia) || isAuthenticatedIdPositiva
      ? true
      : false;
  }

  const caixaMensagens = () => {
    trackServiceSelect('POR-MENU', "CAIXA DE MENSAGEM");
    history.push('/caixa-mensagem');
  };

  const logout = () => {
    dispatch(authLogout({ history }));
  };

  const obterMensagemComTipo = (mensagem, tipoMensagem) => {
    if (!mensagem || !tipoMensagem) {
      return
    }

    return (
      <div>
        <Message
          id="mensagem"
          type={tipoMensagem}
          title={'Atenção'}
          text={mensagem}
          className={styles.message}
        />
      </div>
    );
  };

  const exibirMensagemAjuda = () => {
    setAjudaAcionada(!ajudaAcionada);
    setMensagemAjuda('Tarifa Social de Energia Elétrica - Informações disponibilizadas pela distribuidora de energia elétrica. Para mais informações sobre o benefício, contate a distribuidora de energia elétrica da sua região.');
  }

  const IconeAjuda = () => {
    return (
      <i className={`fas fa-question-circle ${styles.icon}`}
        title="Clique para obter ajuda." onClick={() => exibirMensagemAjuda()}>
      </i>
    )
  }

  const ExtratoBeneficios = () => {
    return (
      <>
        {loadingCount === 0 &&
          <>
            <div className={styles.cardTitle}>
              <i className={`fas fa-hands-helping`}></i>
              <span> Extrato de benefícios</span>
            </div>

            {tiposBeneficios && !tiposBeneficios?.temBeneficiosLinhaDoTempo &&
              <Card className={styles.card}>
                <div className={styles.containerMensagem}>
                  <img className={styles.imgMessage} src={imgAlerta} alt="Imagem de alerta" />
                  <Message type={'warning'}
                    text={
                      <div className={styles.messageText}>
                        <span><strong>Não foram identificados benefícios recebidos por sua família. Foram consultados:</strong></span><br />
                        <span>- Bolsa Família</span><br />
                        <span>- Auxílio Inclusão</span><br />
                        <span>- Benefício de Prestação Continuada (BPC/LOAS).</span><br />
                        {/* <span>- Tarifa Social de Energia Elétrica </span><br/> */}
                      </div>
                    }
                  />
                </div>
              </Card>
            }

            {state.ativarMensagem && loadingCount === 0 &&
              <Card className={styles.card} >
                {obterMensagemComTipo(state.mensagem, state.tipoMensagem)}
              </Card>
            }

            {(tiposBeneficios?.temPAB || tiposBeneficios?.temBPC || tiposBeneficios?.temAI) &&
              tiposBeneficios?.temBeneficiosLinhaDoTempo && loadingCount === 0 && !state.ativarMensagem &&
              <Card className={styles.card} >
                <div className={styles.startHint}>
                  <span className={styles.mainText}>
                    Veja se sua família recebe benefícios do Bolsa Família, Benefício de Prestação Continuada (BPC/LOAS) ou Auxílio Inclusão
                  </span>
                  <div className={styles.startHintTriangle}></div>
                </div>
                {tiposBeneficios?.temBPC &&
                  <div className={`${styles.blocoItem} ${styles.iconeBPC}`} onClick={() => mostrarBPC()}>
                    <div className={styles.blocoItemLeft}>
                      <span className={styles.itemText}>Benefício de Prestação Continuada</span><br />
                    </div>
                  </div>
                }
                {tiposBeneficios?.temPAB &&
                  <div className={`${styles.blocoItem} ${styles.iconeAuxilioBrasil}`} onClick={() => mostrarAuxilioBrasil()}>
                    <div className={styles.blocoItemLeft}>
                      <span className={styles.itemText}>Bolsa Família</span><br />
                    </div>
                  </div>
                }
                {tiposBeneficios?.temAI &&
                  <div className={`${styles.blocoItem} ${styles.iconeBPC}`} onClick={() => mostrarAuxilioInclusao()}>
                    <div className={styles.blocoItemLeft}>
                      <span className={styles.itemText}>Auxílio Inclusão</span><br />
                    </div>
                  </div>
                }
                {/* {tiposBeneficios?.temTSEE &&
                <div className={`${styles.blocoItem} ${styles.iconeBPC}`} onClick={() => mostrarTarifaSocialEnergiaEletrica()}>
                <div className={styles.blocoItemLeft}>
                <span className={styles.itemText}>Tarifa Social de Energia Elétrica</span><br/>
                </div>
                </div>
              } */}
              </Card>
            }

            {tiposBeneficios?.temBeneficiosLinhaDoTempo && loadingCount === 0 && !state.ativarMensagem &&
              <div>
                {!tiposBeneficios?.temPAB && !tiposBeneficios?.temBPC && !tiposBeneficios?.temAI &&
                  <Card className={styles.card} >
                    <div>
                      <span className={styles.mainText}>
                        Não foram encontrados benefícios ativos do Bolsa Família, Benefício de Prestação Continuada (BPC/LOAS), ou Auxílio Inclusão para sua família.
                      </span>
                    </div>
                  </Card>
                }

                <Card className={styles.cardIrregularCorner} >
                  <div className={styles.textoCentralizado} onClick={() => mostrarTodos()}>
                    <div className={styles.titulo}>Linha do tempo de benefícios</div>
                    <div className={styles.texto}>Veja o histórico de benefícios já recebidos por sua família</div>
                  </div>
                </Card>
              </div>
            }
          </>
        }
      </>
    )
  }

  const ExtratoConsignado = () => {
    return (
      <>
        {loadingCount === 0 &&
          <>
            <div className={styles.cardTitle}>
              <i className={`fas fa-dollar-sign`}></i>
              <span>Extrato de empréstimos consignados</span>
            </div>

            <Card className={styles.card} >
              {state.ativarMensagemConsignado && !extratosConsignado &&
                <>
                  {obterMensagemComTipo(state.mensagemConsignado, state.tipoMensagemConsignado)}
                </>
              }
              {extratosConsignado && extratosConsignado.length > 0 &&
                <>
                  <div className={styles.startHint}>
                    <span className={styles.mainText}>
                      Veja se sua família contratou um empréstimo consignado
                    </span>
                    <div className={styles.startHintTriangle}></div>
                  </div>
                  <div className={`${styles.blocoItem} ${styles.iconeBPC}`} onClick={() => mostrarExtratoConsignado()}>
                    <div className={styles.blocoItemLeft}>
                      <span className={styles.itemText}>Empréstimo consignado</span><br />
                    </div>
                  </div>
                </>
              }
              {!!extratosConsignado && extratosConsignado.length === 0 &&
                <div className={styles.containerMensagem}>
                  <Message type={'warning'}
                    text={
                      <div className={styles.messageText}>
                        <span><strong>Não foram identificados empréstimos consignados para sua família.</strong></span><br />
                      </div>
                    }
                  />
                </div>}
            </Card>
          </>
        }
      </>
    )
  }

  const competenciaTarifaSocialEnergiaEletrica = (competencia: any) => {
      const mes = obterMesAnoExtenso(competencia);
      return `${mes?.mesExtenso.toUpperCase()}/${mes?.anoCompetencia}`;
  }

  const TarifaSocialEnergiaEletrica = () => {
    return (
      <>
        {loadingCount === 0 &&
          <>
            <div className={styles.cardTitle}>
              <i className={`fas fa-lightbulb`}></i>
              <span>Tarifa Social de Energia Elétrica {tiposBeneficios?.temTSEE}</span>
            </div>

          <Card className={styles.textoCentralizado} >
            <div className={styles.cardContent}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                  <div className={styles.blocoTitulo}>
                    <div className={styles.tituloSubtitulo}>
                      {tiposBeneficios?.temTSEE &&
                        <>
                          <div className={styles.tituloTextoPadrao}>Tarifa Social de Energia Elétrica<IconeAjuda /></div>
                          <div className={styles.textoPadrao}><strong>Distribuidora:</strong> {tiposBeneficios?.tarifaSocialEnergiaEletrica?.nomeDistribuidora}</div>
                          <div className={styles.textoPadrao}><strong>Unidade consumidora:</strong> {tiposBeneficios?.tarifaSocialEnergiaEletrica?.numeroUnidadeConsumidora}</div>
                          <div className={styles.textoPadrao}><strong>Última competência:</strong> {competenciaTarifaSocialEnergiaEletrica(tiposBeneficios?.tarifaSocialEnergiaEletrica?.numeroCompetencia)}</div>
                        </>
                      }
                      {!tiposBeneficios?.temTSEE &&
                        <>
                          <Message
                            type="warning"
                            className={styles.message}
                            title={`Não foi identificado TSEE para a sua família.`}
                          />
                        </>
                      }
                    </div>
                  </div>
                </Grid>
              </Grid>
            </div>
          </Card>
          </>
        }



      </>
    )
  }

  const SkeletonBeneficios = () => {
    return (
      <>
        {!state.ativarMensagem && loadingCount > 0 &&
          <>
            <Card className={styles.card} >
              <Skeleton count={12} />
            </Card>
            <Card className={styles.card} >
              <Skeleton count={4} />
            </Card>
            <Card className={styles.card} >
              <Skeleton count={6} />
            </Card>
            <Card className={styles.card} >
              <Skeleton count={4} />
            </Card>
          </>
        }
      </>
    )
  }

  const AjudaBeneficios = () => {
    return (
      <>
        {
          loadingCount === 0 &&
          <>
            <AjudaRapida>
              <div className={styles.textoAjudaRapida}>
                <strong>Benefício de Prestação Continuada</strong>
                <br />
                <br />
                  É um benefício individual que garante a transferência de um salário mínimo à pessoa idosa (a partir de 65 anos) e à pessoa com deficiência de qualquer idade, com renda familiar inferior a 1/4 (um quarto) do salário mínimo por pessoa.
                <br />
                <br />
                <strong>Bolsa Família</strong>
                <br />
                <br />
                  Benefício pago a famílias em situação de extrema pobreza e pobreza inscritas no Cadastro Único.
                <br />
                <br />
                <strong>Auxílio Inclusão</strong>
                <br />
                <br />
                  É um benefício individual mensal no valor de meio salário mínimo pago à pessoa com deficiência beneficiária do Benefício de Prestação Continuada (BPC) que ingressar no mercado de trabalho. Para mais informações, consulte o INSS, por meio do telefone gratuito 135 ou do aplicativo Meu INSS.
                <br />
                <br />
                <strong>Empréstimo consignado</strong>
                <br />
                <br />
                  É um tipo de empréstimo que permite que os beneficiários de programas assistenciais do Governo Federal, como Bolsa Família (PBF), tenham descontados de seus benefícios as parcelas dos empréstimos contratados em instituições financeiras habilitadas junto ao Ministério do Desenvolvimento e Assistência Social, Família e Combate à Fome.
                  <br />
                <br />
                <strong>Tarifa Social de Energia Elétrica</strong>
                <br />
                <br />
                  Desconto na conta de luz para famílias de baixa renda ou que tenham algum componente beneficiário do Benefício de Prestação Continuada (BPC). Famílias indígenas ou quilombolas que se encaixem nos critérios podem ter desconto de 100%.
              </div>
            </AjudaRapida>
          </>
        }
      </>
    )
  }

  const MaisOpcoes = () => {
    return (
      <>
        {loadingCount === 0 &&
          <div className={styles.moreOptionsWrapper}>
            <Accordion id="more-options" title="Mais opções" className={styles.moreOptions} scroll>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Card className={styles.moreOptionsCard}>
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <div className={styles.moreOptionsLeftPanel}>
                          <div className={styles.moreOptionsTitulo}>Conheça os programas sociais do Governo Federal</div>
                          <BrButton
                            onClick={() => mostrarProgramasSociais()}
                            className={styles.moreOptionsButton}
                          >
                            Conhecer programas
                          </BrButton>
                        </div>
                      </Grid>
                      <Grid item xs={6}>
                        <div className={styles.moreOptionsLegenda}>
                          Conheça todos os programas sociais disponíveis.
                        </div>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
              </Grid>
            </Accordion>
          </div>
        }
      </>
    )
  }

  return (
    <MainContainer
      userNav={isLogado()}
      navTitle={obterNomeDoPerfil(perfil, situacaoCadastroFamilia)}
      titleBarraAuxiliar={"Meus Benefícios "}
      barraAuxiliar={true}
      navFixed
      stoppedTitle={true}
      navSeparator={false}
      navCaixaMensagens={isLogado() ? caixaMensagens : undefined}
      navLogout={logout}
      navGoBack={voltarParaPainel}>

      <div className={styles.container} id="topo">
        <>
          <Dialog
            open={ajudaAcionada}
            onClose={() => setAjudaAcionada(!ajudaAcionada)}
          >
            <div className={styles.container}>
              <DialogContent>
                <div className={styles.textoDialogo}>
                  {mensagemAjuda}
                </div>
              </DialogContent>
              <div className={styles.modalFooter}>
                <BrButton className={styles.button} onClick={() => setAjudaAcionada(false)}>
                  OK
                </BrButton>
              </div>
            </div>
          </Dialog>

          <SkeletonBeneficios />
          <ExtratoBeneficios />
          <TarifaSocialEnergiaEletrica />
          <ExtratoConsignado />
          <AjudaBeneficios />

        </>
      </div>
      <MaisOpcoes />
    </MainContainer>
  )
}

export default PainelBeneficios;
